export const SECTIONS = {
  SAVINGS: "Vi har sparat",
  ECONOMY: "ekonomi",
  WATER: "vatten",
  CARBON_DIOXIDE: "koldioxid",
  MICROPLASTICS: "mikroplast",
  SHARE_SAVINGS: "Dela din besparing",
  SAVINGS_OVER_TIME: "Se besparing över tid",
  CONTACT: "Vi vill veta vad ni tycker!",
  LAUNDRY: "I tvättstugan just nu",
};
